// components/Orders/StateBadge.js
// ─────────────────────────────────────────────────────────────────────────────
// The payment-state and delivery-state pills, drawn from the one theme in
// utilities/paymentStatus.js so an order reads the same on a table row and
// on its detail page. A pill always carries its WORD: the brand order page
// used to show payment as a bare card icon in a green or slate circle, which
// told a reader nothing unless they already knew the colour code.
// ─────────────────────────────────────────────────────────────────────────────

import React from "react";
import {
  getPaymentState,
  PAYMENT_STATE_CFG,
  PAYMENT_STATE_LABEL,
  getDeliveryCfg,
} from "../../utilities/paymentStatus";

const pillStyle = (cfg) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "3px 10px",
  borderRadius: 999,
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  whiteSpace: "nowrap",
  lineHeight: 1.6,
  background: cfg.bg,
  color: cfg.color,
  border: `1px solid ${cfg.border}`,
});

const Pill = ({ cfg, label, title }) => (
  <span style={pillStyle(cfg)} title={title}>
    {cfg.icon ? <i className={`fas ${cfg.icon}`} aria-hidden="true" /> : null}
    {label}
  </span>
);

/** PAID / PENDING / FAILED / COD / NOT CHARGED for the whole order. */
export const PaymentStateBadge = ({ order, title }) => {
  const state = getPaymentState(order);
  return (
    <Pill
      cfg={PAYMENT_STATE_CFG[state]}
      label={PAYMENT_STATE_LABEL[state]}
      title={title}
    />
  );
};

/** The delivery_status as its human label (Processing, Dispatched, ...). */
export const DeliveryStateBadge = ({ status, title }) => {
  const cfg = getDeliveryCfg(status);
  return <Pill cfg={cfg} label={cfg.label} title={title} />;
};

export default PaymentStateBadge;
